import _ from 'underscore';

import View from './view';

import { suggest } from '../ui/helpers/suggest';
import { find } from '../utils/strings';
import { promisify } from '../utils/promisify';





// todo: bind into the model
export default View.extend( {

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );

        // todo: cancel pgdn
        // todo: correct handle click on OK/Apply
        this.suggestionInterface_ = suggest( this.$el, `[type=text]`, ($htmlInput, page, firstSearch) => {
            if (!this.model)
                return [];

            const fn = typeof this.options.options === 'function' &&
                this.options.options;
            const data = [...this.datalist_];
            // const data = [...this.datalist_, ...fn ? fn() : []];

            const q = $htmlInput.val().trim();
            const prefilteredOptions = q && !firstSearch
                ? data.filter( ({ title, id }) => find( [title, id], q ) )
                : data;

            const limit = 10;
            const offset = page * 10;
            const pagePrefilteredOptions = prefilteredOptions
                .filter( (option, index) => index >= offset && index < (offset + limit) )

            if (!fn || prefilteredOptions.length >= offset + limit) {
                return {
                    options: pagePrefilteredOptions,
                    total: prefilteredOptions.length,
                    page, offset, limit,
                };
            }

            const remoteQ = q && !firstSearch ? q : '';
            const remoteOffset = Math.max( 0, offset - prefilteredOptions.length );
            const remoteLimit = Math.min( limit, offset + limit - prefilteredOptions.length );
            const remoteArgs = [remoteQ, remoteOffset, remoteLimit, this.$el];
            return promisify( fn( ...remoteArgs ) ).then( result => {
                if (result instanceof Array) {
                    // offset, limit, q - ignored
                    const prefilteredOptions = q && !firstSearch
                        ? [...data, ...result].filter( ({ title, id }) => find( [title, id], q ) )
                        : [...data, ...result];

                    const pagePrefilteredOptions = prefilteredOptions
                        .filter( (option, index) => index >= offset && index < (offset + limit) )

                    return {
                        options: pagePrefilteredOptions,
                        total: prefilteredOptions.length,
                        page, offset, limit,
                    };
                } else {
                    return {
                        options: [...pagePrefilteredOptions, ...result.options],
                        total: prefilteredOptions.length + result.total,
                        page, offset, limit
                    }
                }
            } ).catch( ex => console.error( ex ) );
        }, ($htmlInput, title, option) => {
            $htmlInput
                .add( this.$( '.--hidden-title' ) )
                .val( title || '' );
            const $hidden = this.$( '.--hidden-id' );
            $hidden[0].dataset.title = title || '';
            $hidden.val( option.id || '' );
            $hidden.trigger( 'change' );
            if (this.model && $hidden[0].dataset.bind)
                // hack! (change:fields to force readonly to work) todo: no hack
                if ($hidden[0].dataset.bind.includes( ':prepareCf(' ))
                    this.model.trigger( 'change' ),
                    this.model.trigger( 'change:fields' );
            this.suggestionInterface_.hideSuggestion();
        }, $htmlInput =>
            $htmlInput.val( this.$( '.--hidden-title' ).val() ),
        (current, items) => {} );
    },

    serialize() {
        const { bind, label, 
            name, options, disabled, enabled, onlyId, } = this.options;
        return { 
            bind, label, 
            name, options, disabled, enabled, onlyId,
            'messages-for': this.options['messages-for'] 
        };
    },

    afterRender() {
        this.suggestionInterface_.unbindEvents();
        this.suggestionInterface_.bindEvents();

        const options = this.$( 'datalist option' ).toArray();
        this.datalist_ = options.map( option => ({ id: option.value || null, title: option.innerText || '' }));
    },

    bindingHandlers: {
        
        substituteOption: {

            set($el, args) {
                // custom field
                if (!(args instanceof Array)) 
                    args = [args];
                const [option, label/*, meta*/] = args;
                if (label !== undefined)
                    $el.closest( '.form-group' ).children( 'label' ).text( label || '' )

                const id = this.view.options.onlyId
                    ? option
                    // todo
                    : (option && option.id || option && option.object_id);

                $el.val( id || '' );

                const $titles = this.view.$( '.--hidden-title, [type=text]' );

                if (this.view.options.onlyId)
                    // option is ID
                    findOption( this.view, option, title => $titles.val( title || '' ) );
                else if (option === null || option === undefined)
                    findOption( this.view, option, title => $titles.val( title || '' ) );
                else
                    $titles.val( option && option.name || option && option.title || '' )
            },

            get($el, prevValue) {
                const id = $el.val() != '' 
                    ? isNaN( +$el.val() )
                        ? $el.val()
                        : +$el.val()
                    : null;
                const title = $el[0].dataset.title;

                const value = this.view.options.onlyId 
                    ? id 
                    : id != null
                        ? { id, title }
                        : null;

                // ordinal field
                if (!(prevValue instanceof Array))
                    return this.view.options.bind
                        ? { [this.view.options.bind]: value }
                        : value;

                // custom field
                const [prev, label, meta] = prevValue;
                return [value, label, meta];
            }

        }

    },

} );

function findOption(view, id, callback) {
    const matchFn = option => {
        if (option.id == id) 
            return true;

        if (id === null || id === undefined)
            return !option.id;

        return false;
    };

    let [option] = view
        .$( 'datalist option' ).toArray()
        .map( opt => ({ id: opt.value, title: opt.innerText }) )
        .filter( matchFn );
    if (option)
        return callback( option.title );

    let fn = view.options.options;
    fn = typeof fn == 'function' && fn;
    if (!fn)
        return callback( null );

    const response = fn();
    if (response instanceof Promise)
        return response
            .then( options => options || [] )
            .then( options => options.filter( matchFn ) )
            .then( ([option]) => callback( option ? option.title : null ) );

    if (response instanceof Array)
        return [option] = response.filter( matchFn ),
            callback( option ? option.title : null );

    return callback( null );
}



// WEBPACK FOOTER //
// ./src/js/view/field.suggest.js